export default "__VITE_ASSET__B0u16AIJ__"